<template>
  <div v-if="isValidResetToken" class="auth-page">
    <div class="container page d-flex h-100">
      <div class="row w-100 align-items-center">
        <div class="col-md-6 offset-md-3 col-xs-12">
          <card title="Update Password">
            <form v-on:submit.prevent="onSubmit">
              <fieldset class="form-group">
                <input
                  class="form-control form-control-lg mb-3"
                  type="password"
                  v-model="user.password"
                  placeholder="password"
                />
                <input
                  class="form-control form-control-lg"
                  type="password"
                  v-model="user.confirmPassword"
                  placeholder="confirm password"
                />
              </fieldset>
              <p class="text-center text-secondary" v-if="user.confirmPassword.length && !isPasswordsMatch">Passwords do not match.</p>
              <button :disabled="!isPasswordsMatch" class="btn btn-primary pull-xs-right">
                Update Password
              </button>
              <p class="text-xs-center mt-4">
                <router-link :to="{ name: 'login' }">
                  Back to login
                </router-link>
              </p>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CHECK_RESET_TOKEN, USER_UPDATE_PASSWORD } from '@/store/actions.type'

export default {
  data() {
    return {
      isValidResetToken: false,
      user: {
        password: '',
        confirmPassword: ''
      }
    };
  },

  computed: {
    isPasswordsMatch () {
      return this.user.password === this.user.confirmPassword
    }
  },

  methods: {
    onSubmit() {
      const resetToken = this.$route.params.resetToken
      const user = this.user
      this.$store
        .dispatch(USER_UPDATE_PASSWORD, { resetToken, user })
        .then((res) => {
          if (res) {
            this.$router.push({ name: "login" })
          }
        })
    }
  },

  beforeMount() {
    // check if reset token is valid
    const resetToken = this.$route.params.resetToken
    const user = this.user
   
    this.$store.dispatch(CHECK_RESET_TOKEN, { resetToken, user })
      .then((res) => {
          this.isValidResetToken = true
        if (!res) {
          this.$router.push({ name: "reset password" })
        }
      })
      .catch(() => {
        // something went wrong
      })
  }
}
</script>
<style lang="scss" scoped>
.auth-page {
  background-color: #eaeaea;
  background-image: url('https://picsum.photos/1920/1080');
  background-size: cover;
  height: 100vh;
}
</style>
